import { Box, Container, Grid } from '@material-ui/core';
import { LargeSectionHeader, ShortBody } from 'components/Typography';
import { HeaderWrapper, StyledDiv } from 'components/CommonLayout/styles';
import React from 'react';
import styled from 'styled-components';

interface headerProps {
  title: string;
  icon?: React.ReactNode;
  subTitle?: string;
}
const Header = ({ title, icon, subTitle }: headerProps) => {
  return (
    <HeaderWrapper>
      <Container maxWidth="lg">
        <Box paddingTop={[9, 11, 13]}>
          <StyledBox marginBottom={5}>
            <Grid container alignItems="center" justify="center">
              <StyledDiv>
                <LargeSectionHeader color="#FFFFFF" weight="500">
                  {icon} {title}
                </LargeSectionHeader>
              </StyledDiv>
            </Grid>
            <Grid container alignItems="center" justify="center">
              <ShortBody color="#FFFFFF" weight="500">
                {subTitle}
              </ShortBody>
            </Grid>
          </StyledBox>
        </Box>
      </Container>
    </HeaderWrapper>
  );
};

const StyledBox = styled(Box)`
  &&& {
    text-align: center;
  }
`;
export default Header;
